import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-icons-download",
  "use": "tc-icons-download-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-icons-download\"><g stroke=\"#31251c\"><path d=\"m15.75 11.25v3c0 .3978-.158.7794-.4393 1.0607s-.6629.4393-1.0607.4393h-10.5c-.39782 0-.77936-.158-1.06066-.4393s-.43934-.6629-.43934-1.0607v-3\" /><path d=\"m5.25 7.5 3.75 3.75 3.75-3.75\" /><path d=\"m9 11.25v-9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol